import Vue from 'vue'
import App from './App.vue'
import 'lib-flexible/flexible.js'
import VueAwesomeSwiper from 'vue-awesome-swiper'
import 'swiper/dist/css/swiper.css'
import axios from 'axios'
import animate from 'animate.css'
import layer from 'vue-layer'
import 'vue-layer/lib/vue-layer.css';
import router from './router'
Vue.prototype.$layer = layer(Vue);
Vue.use(layer)
Vue.prototype.$axios = axios
Vue.use(VueAwesomeSwiper, /* { default global options } */)
Vue.config.productionTip = false
Vue.prototype.Breaks = function (data) {
  let textArray = data.split("==");
  let title = "";
  textArray.map(item => {
    title += "<span class='u-newsType3Ttitle'>" + item + "</span>"
  })
  console.log(title)
  // return data.replace(/\s+/g,"<br/>")
  return title
}
Vue.prototype.Trim = function (str) {
  return str.replace(/(^\s*)|(\s*$)/g, "");
}
// Vue.prototype.getWatch =  function(num) {
//     if( num < 10000) {
//       return num;
//     }else {
//       return  (num/10000).toFixed(2) + "万"
//     }
// }


Vue.prototype.support = function (e, id, array) {
   console.log(id)
  if (e.target.className.indexOf('active') == -1) {
    axios({
      method: 'post',
      url: '/api/articles/support_article',
      data: {
        article_id: id
      }
    }).then(res => {
      console.log(e.target)

      e.target.classList.add('active')
      array.support_counts += 1
    })
  }
}

new Vue({
  router,
  render: h => h(App),
}).$mount('#app')
